exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-a2b160da] .el-dialog__title {\n  font-size: 25px;\n  color: #606266;\n}\n[data-v-a2b160da] .el-form-item__label {\n  font-family: Arial, Helvetica, sans-serif;\n}\n.input-common[data-v-a2b160da] {\n  margin-right: 5px;\n}\n.el-row[data-v-a2b160da] {\n  margin-bottom: 5px;\n  font-size: 16px;\n  color: white;\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n}\n.el-col[data-v-a2b160da] {\n  padding: 9px 5px;\n}\n[data-v-a2b160da] .el-dialog__body {\n  padding-top: 0px;\n}\n", ""]);

// exports
